import { Meta } from '@atlassian/mpac-primitives';
import React from 'react';

import type { AppListingImage } from '@atlassian/mpac-app-listing';
import type { AppListingCanonicalLink, MediaFileLink } from '@atlassian/mpac-types';

import AtlassianLogoCompactBlue from '../../../../../../../assets/images/AtlassianLogoCompactBlue.png';

export type AppListingMetaProps = {
  appId: string;
  appName: string;
  appSlug: string;
  appDescription: string | null | undefined;
  canonicalLink: AppListingCanonicalLink;
  mediaImageLink: MediaFileLink;
  image: AppListingImage | null | undefined;
  logo: AppListingImage | null | undefined;
};

export const makeImageUrl = (mediaImageLink: MediaFileLink, img?: AppListingImage | null) => {
  if (!img) return AtlassianLogoCompactBlue;
  const imageId = img.highResolution?.id || img.original.id;
  return mediaImageLink.expand({ imageId });
};

const AppListingMeta = ({
  appDescription,
  appId,
  appSlug,
  appName,
  canonicalLink,
  mediaImageLink,
  image,
  logo,
}: AppListingMetaProps) => {
  return (
    <Meta
      description={appDescription}
      canonicalUrl={canonicalLink.expand({ appId, slug: appSlug })}
      title={appName}
      image={makeImageUrl(mediaImageLink, image)}
      twitterImage={makeImageUrl(mediaImageLink, logo)}
    />
  );
};

export default AppListingMeta;
